const r2 = (n) => Math.round((Number(n) + 1e-9) * 100) / 100;

export function calcTaxes(lines, rules) {
  const active = Object.fromEntries((rules || []).filter((r) => r.active).map((r) => [r.code, r]));
  const br = {};
  let subtotal = 0;
  lines.forEach((l) => {
    const base = r2(Number(l.quantity || 0) * Number(l.unit_price || 0));
    subtotal += base;
    (l.tax_codes || []).forEach((c) => {
      const r = active[c];
      if (!r) return;
      br[c] = br[c] || { code: c, name: r.name, kind: r.kind, rate: r.rate, amount: 0 };
      br[c].amount = r2(br[c].amount + (base * r.rate) / 100);
    });
  });
  const list = Object.values(br);
  const tax = r2(list.filter((b) => b.kind !== "withholding").reduce((s, b) => s + b.amount, 0));
  const wht = r2(list.filter((b) => b.kind === "withholding").reduce((s, b) => s + b.amount, 0));
  return { subtotal: r2(subtotal), breakdown: list, tax, wht, total: r2(subtotal + tax - wht) };
}

export const defaultCodes = (rules) => (rules || []).filter((r) => r.active && r.default).map((r) => r.code);
